import * as FileConstants from 'folder-items/FileConstants';
import {Organization} from 'orgs/OrganizationConstants';
import {Schema} from 'schemas/SchemaConstants';
import {TagUpdateObject} from 'schemas/tags/TagUtil';
import {Optional} from 'util/Types';
import {SampleGroupSchema} from 'workflows/WorkflowConstants';

import {RequestTaskGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTaskGraphQL';
import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';

type Tag = FileConstants.Tag;

export interface RequestTaskSchema extends Schema {
  name: string;
  organization: Organization;
  sqlIdentifier: string;
  sampleGroupSchema?: Optional<SampleGroupSchema>;
}

type BaseRequestTask<TId> = {
  schemaId: string;
} & TId;

interface ClientId {
  cid: string;
}

interface ServerId {
  id: string;
  requestId: string;
}

interface RequestTags {
  tags: Array<Tag>;
}

interface ServerRequestTags {
  tags: TagUpdateObject;
}

// RequestTask that hasn't been persisted on the server yet.
export type UIRequestTask = BaseRequestTask<ClientId> & RequestTags;
export type RequestTask = BaseRequestTask<ServerId> & RequestTags;

// ServerRequestTasks are RequestTasks that have been translated into a format the server can understand.
export type ServerRequestTask = BaseRequestTask<ServerId> & ServerRequestTags;
export type ServerUIRequestTask = BaseRequestTask<ClientId> & ServerRequestTags;

export const SCHEMA_ID_REQUEST_TASK_SCHEMA_ALL = 'SCHEMA_ID_REQUEST_TASK_SCHEMA_ALL';

export function isRequestTaskSchema(
  schema?: {
    id: string;
    __typename?: string;
  } | null
): schema is RequestTaskSchemaGraphQL {
  return schema ? schema.__typename === 'RequestTaskSchemaNode' : false;
}

export function isRequestTaskGraphQL(
  requestTask: {id: string; __typename?: string} | {cid: string}
): requestTask is RequestTaskGraphQL {
  return (
    requestTask.hasOwnProperty('__typename') &&
    (requestTask as {__typename: string}).__typename === 'RequestTaskNode'
  );
}
